import React, { FC } from 'react';
import { ScrollView } from 'react-native';
import { Formik } from 'formik';
import AlreadyAMemberLink from '../../components/styled/AlreadyAMemberLink';
import EmailInput from '../../components/styled/EmailInput';
import HeaderOne from '../../components/styled/HeaderOne';
import HeaderTwo from '../../components/styled/HeaderTwo';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import Logo from '../../components/styled/Logo';
import PasswordInput from '../../components/styled/PasswordInput';
import UserLogoInput from '../../components/styled/UserLogoInput';
import UserRoleSelection from '../../components/styled/UserRoleSelection';
import TermsOfService from '../../components/styled/TermsOfService';
import View from '../../components/styled/View';
import ErrorText from '../../components/styled/ErrorText';
import { signUpValidationSchema } from './validationSchema';
import styles from './styles';
import { WELCOME_HEADER, WELCOME_SUB_HEADER } from './constants';

type SignUpScreenProps = {
  navigation: any;
  signUpUser: (values: any) => void;
  signUpError: string;
  signUpLoading: boolean;
};

const SignUpScreen: FC<SignUpScreenProps> = ({
  navigation,
  signUpUser,
  signUpError,
  signUpLoading,
}) => {
  return (
    <ScrollView contentContainerStyle={styles.contentContainer}>
      <View style={styles.logo}>
        <Logo />
      </View>
      <HeaderOne title={WELCOME_HEADER} />
      <View style={styles.subHeader}>
        <HeaderTwo title={WELCOME_SUB_HEADER} />
      </View>
      <>
        <Formik
          initialValues={{
            email: '',
            password: '',
            confirmPassword: '',
            fullName: '',
            userType: 'fan',
            agreedToTerms: false,
          }}
          onSubmit={(values) => signUpUser(values)}
          validationSchema={signUpValidationSchema}
        >
          {({
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid = false,
            setFieldValue,
            touched,
            values,
          }) => (
            <View>
              <UserLogoInput
                errorMessage={touched.fullName && errors.fullName}
                onBlur={handleBlur('fullName')}
                onChangeText={handleChange('fullName')}
                value={values.fullName}
              />
              <EmailInput
                errorMessage={touched.email && errors.email}
                onBlur={handleBlur('email')}
                onChangeText={handleChange('email')}
                value={values.email}
              />
              <PasswordInput
                errorMessage={touched.password && errors.password}
                onBlur={handleBlur('password')}
                onChangeText={handleChange('password')}
                value={values.password}
              />
              <PasswordInput
                errorMessage={touched.confirmPassword && errors.confirmPassword}
                placeholderLabel="Confirm Password"
                onBlur={handleBlur('confirmPassword')}
                onChangeText={handleChange('confirmPassword')}
                value={values.confirmPassword}
              />
              <UserRoleSelection
                setFieldValue={setFieldValue}
                value={values.userType}
              />
              <TermsOfService
                text="I agree to the "
                linkText="Terms of Use"
                onPress={() => navigation.navigate('TermsOfService')}
                isEnabled={values.agreedToTerms}
                toggleSwitch={setFieldValue}
              />
              {!!signUpError && (
                <ErrorText
                  textStyle={styles.signUpErrorText}
                  text={signUpError}
                />
              )}

              <LinearGradientButton
                loading={signUpLoading}
                disabled={!isValid || signUpLoading}
                title="SIGN UP"
                onPress={handleSubmit}
              />
            </View>
          )}
        </Formik>
      </>
      <AlreadyAMemberLink navigation={navigation} />
    </ScrollView>
  );
};

export default SignUpScreen;
